import React, { useState } from 'react';
import { ConsentNotice } from '@/components/ConsentNotice';
import { Link } from 'react-router-dom';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import Footer from '@/components/Footer';

export default function CookieSettingsPage() {
  const [analyticsConsent, setAnalyticsConsent] = useState(() => {
    try { return localStorage.getItem('insul_analytics_consent') === 'accepted'; } catch { return false; }
  });

  const handleToggle = (checked) => {
    try { localStorage.setItem('insul_analytics_consent', checked ? 'accepted' : 'rejected'); } catch {}
    setAnalyticsConsent(checked);
    if (checked) {
      window.__insulInitAnalytics?.();
      window.posthog?.opt_in_capturing?.();
      toast.success('Optional analytics enabled');
    } else {
      window.posthog?.opt_out_capturing?.();
      window.posthog?.stopSessionRecording?.();
      toast.success('Optional analytics disabled');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex flex-col">
      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full" data-testid="cookie-settings-page">
        <h1 className="text-3xl font-bold mb-6">Cookie &amp; Analytics Settings</h1>
        <div className="space-y-6 text-muted-foreground">
          <div className="rounded-2xl border border-border bg-card p-6">
            <div className="flex items-center justify-between gap-6">
              <div>
                <p className="font-semibold text-foreground">Essential</p>
                <p className="text-sm">Required for login sessions and core functionality. Always on.</p>
              </div>
              <Switch checked disabled data-testid="essential-cookies-switch" />
            </div>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <div className="flex items-center justify-between gap-6">
              <div>
                <p className="font-semibold text-foreground">Optional analytics (PostHog)</p>
                <p className="text-sm"><ConsentNotice slot="cookie_banner">Helps us understand how the app is used. The app works fully without it.</ConsentNotice></p>
              </div>
              <Switch
                data-testid="cookie-analytics-toggle"
                checked={analyticsConsent}
                onCheckedChange={handleToggle}
              />
            </div>
          </div>
        </div>
        <Link to="/" className="inline-block mt-8 text-primary font-semibold">← Back to home</Link>
      </main>
      <Footer />
    </div>
  );
}
